import React from "react";
import {
  useSmartDownload,
  getDownloadLabel,
  detectOS,
  isMacComingSoon,
  DOWNLOAD_GRADIENT,
  MAC_COMING_SOON_LABEL_SHORT,
} from "../../hooks/useSmartDownload";
import DownloadOSIcon from "./DownloadOSIcon";

/**
 * Navbar variant of the OS-aware download button: the OS icon is shown plain in
 * white (no white circle behind it). Triggers the same smart download as the
 * home CTAs — Windows downloads the installer + shows the modal, Android opens
 * Play Store, Mac/iPhone route to the /download page.
 *
 * `className` sizes the button and `iconClassName` sizes the icon.
 */
const NavDownloadButton = ({
  className = "",
  iconClassName = "",
  location = "navbar",
  showIcon = true,
  compact = false,
}) => {
  const smartDownload = useSmartDownload();
  // On tight layouts (mobile navbar) show just "Download" beside the OS icon,
  // instead of the full "Download for Android/Windows/…" label which overflows.
  // On Mac the short label still has to say "Coming Soon", not "Download".
  const compactLabel =
    detectOS() === "mac" ? MAC_COMING_SOON_LABEL_SHORT : "Download";
  const label = compact ? compactLabel : getDownloadLabel();
  // On Mac the button only announces the upcoming build, so it isn't clickable.
  const comingSoon = isMacComingSoon();

  return (
    <button
      type="button"
      disabled={comingSoon}
      aria-disabled={comingSoon}
      onClick={() => smartDownload(location)}
      style={{ background: DOWNLOAD_GRADIENT }}
      className={`${
        comingSoon ? "cursor-not-allowed" : "hover:opacity-90 cursor-pointer"
      } transition-all duration-300 ease-in-out font-inter text-white font-semibold flex items-center justify-center gap-2 rounded-full ${className}`}
    >
      {showIcon && <DownloadOSIcon className={`text-white ${iconClassName}`} />}
      {label}
    </button>
  );
};

export default NavDownloadButton;
